import React, { useEffect, useState } from "react";
import AnimatedTextInput from "./animatedTextInput";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import {
  isDevanagariPincode,
  isValidPincode,
  parseNumberFromAnotherLocale,
} from "../utils";

function Address({ onSubmitHandler, initState = null }) {
  const [state, setState] = useState(
    initState || {
      text: "",
      pin: "",
    }
  );
  const [locationPinCodeInput, setLoactionPinCodeInput] = useState("");
  const [area, setArea] = useState("");
  const [areas, setAreas] = useState([]);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const { t } = useTranslation();
  const getAreaURL = (pincode) => `/api/v1/pincode/${pincode}`;

  const handleChange = (e) => {
    setLoactionPinCodeInput(e.target.value);
    /*
    setState({
      ...state,
      [e.target.id]: e.target.value
    });
     */
  };

  useEffect(() => {
    if (locationPinCodeInput.length >= 2) {
      //TODO: Improve validation
      console.log(locationPinCodeInput);
      try {
        const parsedLoactionPin = isDevanagariPincode(locationPinCodeInput)
          ? parseNumberFromAnotherLocale(locationPinCodeInput)
          : locationPinCodeInput;
        setAreaOptions(parsedLoactionPin);
      } catch (e) {
        setAreas([]);
        setShowError(true);
        setErrorMessage("Unable to parse pin code");
      }
    } else {
      console.log("Search input too short");
    }
  }, [locationPinCodeInput]);

  const setAreaOptions = (pin) => {
    setIsFetching(true);
    setArea("");
    fetch(getAreaURL(pin), { method: "GET" })
      .then((response) => response.json())
      .then((responseData) => {
        console.log(responseData);
        if (responseData && responseData["status"]["success"]) {
          const allAreas = responseData["postOffice"];

          console.log("all areas", allAreas);
          setAreas(allAreas);
          setShowError(false);
          setErrorMessage("");
        } else {
          setAreas([]);
          setShowError(true);
          setErrorMessage(responseData[0].Message);
        }
        setIsFetching(false);
      })
      .catch((err) => {
        setAreas([]);
        setShowError(false);
        setIsFetching(false);
      });
  };

  const areaChanged = (area) => {
    console.log(area);
    setArea(area);
  };

  const canContinue = () => {
    if (isFetching) return false;
    if (areas.length > 0) {
      return (
        locationPinCodeInput !== "" &&
        locationPinCodeInput.length >= 2 &&
        area !== "" &&
        !showError
      );
    } else {
      return (
        locationPinCodeInput !== "" &&
        locationPinCodeInput.length >= 2 &&
        !showError
      );
    }
  };

  const Choices = areas.map((area, index) => {
    return (
      <li key={index}>
        <label>
          <input
            type="radio"
            name="area"
            value={area?.name}
            id={index}
            disabled={areas.length === 0}
            onChange={() => areaChanged(area)}
          />
          <span className="dot"></span>
          <span className="txt">
            {area?.name} - {area?.district}
          </span>
        </label>
      </li>
    );
  });

  return (
    <div className="body_content">
      <div className="inner_body mt-3 ">
        <h3 className="headtitle mb-4">{t("onboard.ADDRESS.question1")}</h3>
        <div className="fill_form light_fill_form">
          <AnimatedTextInput
            label={t("onboard.ADDRESS.pinCodeLocationLbl")}
            value={locationPinCodeInput}
            onChange={handleChange}
            id="pin"
            type={"text"}
          />

          {isFetching ? (
            <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
              }}
              id="loader"
            ></div>
          ) : showError ? (
            <>
              {showError && (
                <p className="err-msg text-danger">{errorMessage}</p>
              )}
            </>
          ) : (
            <>
              {areas.length > 0 && (
                <h3 className="headtitle mt-5 mb-4">
                  {t("onboard.ADDRESS.question2")}
                </h3>
              )}
              <div>
                <ul
                  className="list-unstyled list_radio_btn"
                  style={{
                    overflowY: "scroll",
                    height: "150px",
                    marginRight: "2px",
                  }}
                >
                  {Choices}
                </ul>
              </div>
              {areas.length !== 0 && (
                <div className="px-3 mt-4">
                  {" "}
                  <p>{t("sidenav.ADDRESS.message1")}</p>
                </div>
              )}
            </>
          )}

          <div className="btn_block d-flex justify-content-center bottom_button">
            <button
              className="btn btn_primary"
              disabled={!canContinue()}
              onClick={() =>
                onSubmitHandler({
                  text: area?.name,
                  pin: area?.pincode,
                })
              }
            >
              {t("onboard.ADDRESS.submitButtonText")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Address;
